import * as React from 'react';
import { Fragment } from 'react';
import Pagination from '../components/Pagination';
import { BulkActionProps, BulkDeleteButton, DateInput, List, ListProps, TextInput } from 'react-admin';
import { RecipeCategoryList } from './RecipeCategoryList';
import { RecipeCategoryDatagrid } from './RecipeCategoryDatagrid';
import { Theme, useMediaQuery } from '@material-ui/core';
import { ExportField, generateExporter } from '../util/Exporter';
import { RecipeCategory } from './RecipeCategory';

export * from './RecipeCategory';
export * from './RecipeCategoryCreate';
export * from './RecipeCategoryDatagrid';
export * from './RecipeCategoryEdit';
export * from './RecipeCategoryList';
export * from './RecipeCategoryShow';

const RecipeCategoriesBulkActionButtons = (props: BulkActionProps) => (
	<Fragment>
		<BulkDeleteButton {...props} undoable={false}/>
	</Fragment>
);

export const exportFields: ExportField[] = [
	{ key: 'id', header: 'ID' },
	{ key: 'name', header: 'Name' },
	// { key: 'description', header: 'Description' },
	{ key: 'imageUrl', header: 'Image URL' },
	{ key: 'organization.name', header: 'Organization Name' }
];

export const RecipeCategoriesData = (props: ListProps): React.ReactElement => {
	const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('xs'));
	const exportDataMapper = (entity: RecipeCategory) => entity;

	const recipeCategoriesFilter = [
		<TextInput source="name" alwaysOn label="SEARCH"/>,
		<DateInput source="from__createdAt" label="FROM_CREATED_AT"
		           alwaysOn/>,
		<DateInput source="to__createdAt" label="TO_CREATED_AT"
		           alwaysOn/>
	];

	return (
		<Fragment>
			<List
				exporter={generateExporter('קטגוריות ממתכונים', exportFields, exportDataMapper)}
				{...props}
				filters={recipeCategoriesFilter}
				bulkActionButtons={<RecipeCategoriesBulkActionButtons/>}
				title="RECIPE_CATEGORIES"
				sort={{ field: '_createdAt', order: 'DESC' }}
				perPage={20}
				pagination={<Pagination/>}
			>
				{isXSmall ? <RecipeCategoryList/> : <RecipeCategoryDatagrid/>}
			</List>
		</Fragment>
	);
};
